"use client";

import { c as _c } from "react/compiler-runtime";
import { useAbly } from "ably/react";
import { useEffect } from "react";
import { isUsableUserChannelName } from "@/lib/ablyChannels";
import { useUserChannel } from "../UserChannelProvider";
export const PushSubscriber = () => {
  const $ = _c(4);
  const client = useAbly();
  const {
    channelName
  } = useUserChannel();
  let t0;
  let t1;
  if ($[0] !== channelName || $[1] !== client) {
    t0 = () => {
      if (!isUsableUserChannelName(channelName)) {
        return;
      }
      let unsubscribed = false;
      const subscribeIfReady = async () => {
        if (client.auth.clientId) {
          const channel = client.channels.get(channelName);
          ;
          try {
            await channel.push.subscribeDevice();
          } catch (t2) {
            const err = t2;
            console.warn("Failed to subscribe device to push for channel", channelName, err);
          }
        }
      };
      const onConnected = () => {
        if (!unsubscribed) {
          subscribeIfReady();
        }
      };
      if (client.connection.state === "connected") {
        subscribeIfReady();
      } else {
        client.connection.on("connected", onConnected);
      }
      return () => {
        unsubscribed = true;
        client.connection.off("connected", onConnected);
      };
    };
    t1 = [client, channelName];
    $[0] = channelName;
    $[1] = client;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
};